export default __webpack_public_path__ + "static/media/kanton-banner2.9b4b43a0.jpg";